/*
 * Copyright (c) 2020. Jellybean B.V. Apeldoorn
 * Jellybean B.V. Apeldoorn heeft een licentie verleend aan
 * Spin in het Web B.V. Apeldoorn voor het gebruik van deze software-
 * onderdelen in projecten voor derden. U heeft géén toestemming
 * tot inzage of wijziging in de (bron)code van deze onderdelen.
 */

/*
* datatable.module.ts
* 10-12-2019 - Jelmer Jellema - Spin in het Web B.V.
*/

import {LocalconfigModule} from '../localconfig/localconfig.module';
import {SihwDatatable2} from './datatable2.component';
import {NgModule} from '@angular/core';
import {SihwlogModule} from '../sihwlog/sihwlog.module';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {SihwdatumveldModule} from '../controls/sihwdatumveld/sihwdatumveld.module';

@NgModule({
  declarations: [
    SihwDatatable2
  ],
  imports: [
    LocalconfigModule,
    SihwlogModule,
    CommonModule,
    FormsModule,
    SihwdatumveldModule
  ],
  exports: [SihwDatatable2]

})
export class SihwDatatable2Module {}
